export const ArrowRightAltIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
        <path
            fill="#fff"
            d="M18.853 12.353a.502.502 0 0 0 0-.706l-5.5-5.5a.502.502 0 0 0-.706 0 .502.502 0 0 0 0 .706l4.647 4.647H5.5c-.275 0-.5.225-.5.5s.225.5.5.5h11.794l-4.647 4.647a.502.502 0 0 0 0 .706.502.502 0 0 0 .706 0l5.5-5.5Z"
        />
    </svg>
);
